import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Spinner } from '@streamr/tv-ui';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { BroadcastStateService } from '../../../services/broadcaststate/BroadcastStateService';
import { MediaService } from '../../../services/media/MediaService';
import { RecordingService } from '../../../services/recording/RecordingService';
import { Anchor } from '../../Anchor';
import { PopupCssPreset } from '../../popups/Popup.styles';
import { showStopRecordingPopup, } from '../../popups/recording/StopRecordingPopup';
const mobilePositioningForStopRecordingPopup = {
    fullscreenOnly: true,
};
const desktopPositioningForStopRecordingPopup = {
    fullscreenOnly: false,
    popupCssPresetForDesktop: PopupCssPreset.AnchoredTopCenter,
};
export function ToggleLiveButton(props) {
    const { className, device, broadcastServiceIsRunning, isBroadcasting, onGoLiveClick, onEndBroadcastClick, } = props;
    const [goLiveWasClicked, setGoLiveWasClicked] = useState(false);
    const anchorRef = useRef(null);
    const broadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const recordingService = RecordingService.getNotificationInterface();
    const activeRecording = RecordingService.getOutput().useActiveRecording();
    const mediaOutputMediaStreamData = MediaService.getOutput().useMediaStreamData();
    const onGoLiveClickRef = useRef(onGoLiveClick);
    useEffect(() => {
        if (broadcastServiceIsRunning && goLiveWasClicked) {
            onGoLiveClickRef.current();
        }
    }, [broadcastServiceIsRunning, goLiveWasClicked]);
    useEffect(() => {
        if (isBroadcasting) {
            setGoLiveWasClicked(false);
        }
    }, [isBroadcasting]);
    return isBroadcasting ? (_jsx(Anchor, { ref: anchorRef, children: _jsx(ToggleLiveButtonRoot, { className: className, type: "button", "$device": device, onClick: async () => {
                if (activeRecording &&
                    activeRecording.status === 'recording') {
                    const shouldStop = await showStopRecordingPopup({
                        anchorRef,
                        positioning: device === 'mobile'
                            ? mobilePositioningForStopRecordingPopup
                            : desktopPositioningForStopRecordingPopup,
                        broadcast,
                        isPublic: activeRecording.visibility === 'public',
                    });
                    if (shouldStop) {
                        recordingService.notifyStopRecording(() => {
                            onEndBroadcastClick();
                        });
                    }
                    return;
                }
                recordingService.notifyStopRecording(() => {
                    onEndBroadcastClick();
                });
            }, "$isLive": true, disabled: activeRecording?.status === 'stopping', children: "End" }) })) : (_jsx(ToggleLiveButtonRoot, { "$device": device, className: className, type: "button", onClick: () => {
            //setGoLiveWasClicked(true);
            onGoLiveClick();
        }, "$isLive": false, disabled: goLiveWasClicked ||
            !mediaOutputMediaStreamData.mediaStream.active, children: goLiveWasClicked ? _jsx(StyledSpinner, {}) : 'Go Live' }));
}
const ToggleLiveButtonRoot = styled(Button) `
    --Button_Background: ${({ $isLive }) => ($isLive ? 'var(--tv-ui-color-6)' : 'var(--tv-ui-color-3)')};
    --Button_HoverBackground: ${({ $isLive }) => ($isLive ? 'var(--tv-ui-color-6)' : 'var(--tv-ui-color-3)')};
    --Button_TextColor: ${({ $isLive }) => ($isLive ? 'var(--tv-ui-color-3)' : 'var(--tv-ui-color-1)')};
    --Button_Padding: ${({ $device }) => ($device === 'mobile' ? '0 1rem' : '0 1.5rem')};
    --Button_BorderRadius: 1.5rem;
    --Button_Height: 3rem;
`;
const StyledSpinner = styled(Spinner) `
    --Spinner_Size: 1.5rem;
    --Spinner_TrackColor: var(--tv-ui-color-8);
    --Spinner_Color: var(--tv-ui-color-4);
    --Spinner_Thickness: 2px;
`;
